import { useQuery } from '@tanstack/react-query'
import { useApi } from '@tabeeb/shared/utils/API'
import { UserQueryKeys } from '../requests'

interface UseUserProps {
  id?: number
  identityGuid?: string
  enabled?: boolean
}

export default ({ id, identityGuid, enabled = true }: UseUserProps) => {
  const { mainApi: api } = useApi()

  const userByIdQueryEnabled = enabled && Boolean(id)
  const userByIdentityGuidQueryEnabled = enabled && !id && Boolean(identityGuid)

  const userByIdQuery = useQuery({
    queryKey: [UserQueryKeys.UserById, id],
    queryFn: () => api.users.getUserByIdAsync(id!),
    enabled: userByIdQueryEnabled,
  })

  const userByIdentityGuidQuery = useQuery({
    queryKey: [UserQueryKeys.UserByIdentityGuid, identityGuid],
    queryFn: () => api.users.getUserByIdentityGuidAsync(identityGuid!),
    enabled: userByIdentityGuidQueryEnabled,
    staleTime: 360 * 1000,
  })

  const loading =
    (userByIdQueryEnabled && userByIdQuery.isLoading) ||
    (userByIdentityGuidQueryEnabled && userByIdentityGuidQuery.isLoading)

  const fetching =
    (userByIdQueryEnabled && userByIdQuery.isFetching) ||
    (userByIdentityGuidQueryEnabled && userByIdentityGuidQuery.isFetching)

  const user = userByIdQuery.data || userByIdentityGuidQuery.data

  return { loading, fetching, user }
}
